import { Button } from "@mui/material"
import { IfTooltip } from "lib/if-tooltip"
import { navigateCompareView } from "authoring/routes/project/utilities/project-navigation"
import Iconify from "minimals-template/components/Iconify"
import { useParams } from "react-router"
import { useHasSavedEdits } from "../hooks/use-has-saved-edits"
import { useScheduleEditorSaveDirty } from "../hooks/use-schedule-editor-save-dirty"

export function CompareButton() {
    const { projectId, scheduleId } = useParams()
    const dirty = useScheduleEditorSaveDirty()
    const hasSavedEdits = useHasSavedEdits({ forCompare: true })

    const disabled = dirty || !hasSavedEdits
    const tooltip = dirty ? "Save changes before comparing." : !hasSavedEdits ? "There's nothing to compare." : ""

    const destination = `${projectId}_${scheduleId}`
    return (
        <IfTooltip condition={disabled && !!tooltip} title={tooltip}>
            <Button
                sx={{ color: "primary.main" }}
                data-cy="compare-button"
                startIcon={<Iconify icon="ic:twotone-compare" />}
                onClick={() => navigateCompareView({ destination, source: scheduleId, projectId })}
                variant="outlined"
                disabled={disabled}
            >
                Compare
            </Button>
        </IfTooltip>
    )
}
